import React from "react";
import { ISpaceProps, spacingMap } from "./definitions";

export const Space: React.FC<ISpaceProps> = ({ size }) => {
    return <div style={{ padding: spacingMap[size] }} />;
};
